import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast, Loader, QuantitySelector } from '@grandvisionhq/common';
import { isNil } from '@grandvisionhq/utils';
import { useCart } from '../../../context/Cart/context.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/svc-tealium/events';
import '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import { useAddToCart } from '../../../hooks/use-add-to-cart.js';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import { useSanitization } from '../../../hooks/use-sanitization.js';
import { AddToCart } from '../components/AddToCart.js';
import { ConfirmationModalContainer } from './ConfirmationModalContainer.js';

var AddToCartContainer = (_param)=>{
    var { lineItemDrafts , isQuantityDiscountSelected , onSuccess , isQuantitySelectorEnabled , handleQuantityUpdate , productType , quantity =1  } = _param, buttonProps = swcHelpers.objectWithoutProperties(_param, [
        "lineItemDrafts",
        "isQuantityDiscountSelected",
        "onSuccess",
        "isQuantitySelectorEnabled",
        "handleQuantityUpdate",
        "productType",
        "quantity"
    ]);
    const [addToCart, { loading  }] = useAddToCart();
    const { cart  } = useCart();
    const [{ isModalOpen , sanitizationPayloads , validation  }, { onSolvableValidationError , pushRemoveLineItemDataLayerEvent , reset  }, ] = useSanitization();
    const onValidationError = React.useCallback((validationCodes)=>{
        validationCodes.forEach((code)=>toast.failed(`cart.${code}`)
        );
    }, []);
    const onError = React.useCallback((errorCode)=>{
        toast.failed(`cart.${errorCode}`);
    }, []);
    const handleSuccess = React.useCallback((addedLineItems)=>{
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(addedLineItems);
        reset();
    }, [
        onSuccess,
        reset
    ]);
    const handleOnClick = React.useCallback(()=>{
        addToCart(lineItemDrafts, handleSuccess, onValidationError, onError, onSolvableValidationError, sanitizationPayloads, pushRemoveLineItemDataLayerEvent, isQuantityDiscountSelected);
    }, [
        addToCart,
        lineItemDrafts,
        handleSuccess,
        onValidationError,
        onError,
        onSolvableValidationError,
        sanitizationPayloads,
        pushRemoveLineItemDataLayerEvent,
        isQuantityDiscountSelected, 
    ]);
    const handleDecreaseQuantity = React.useCallback(()=>{
        handleQuantityUpdate && handleQuantityUpdate(quantity - 1);
    }, [
        handleQuantityUpdate,
        quantity
    ]);
    const handleIncreaseQuantity = React.useCallback(()=>{
        handleQuantityUpdate && handleQuantityUpdate(quantity + 1);
    }, [
        handleQuantityUpdate,
        quantity
    ]);
    if (!lineItemDrafts.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !isNil(validation) && /*#__PURE__*/ React.createElement(ConfirmationModalContainer, {
        lineItems: cart === null || cart === void 0 ? void 0 : cart.lineItems,
        handleOnAction: handleOnClick,
        handleOnCancel: reset,
        isLoading: loading,
        isOpen: isModalOpen,
        onModalClose: reset,
        validation: validation
    }), buttonProps.variant === 'ghost' ? loading ? /*#__PURE__*/ React.createElement(Loader, {
        className: "add-to-cart-container__loader"
    }) : /*#__PURE__*/ React.createElement("div", {
        className: "add-to-cart-container"
    }, isQuantitySelectorEnabled && quantity && /*#__PURE__*/ React.createElement(QuantitySelector, {
        onDecreaseQuantity: handleDecreaseQuantity,
        onIncreaseQuantity: handleIncreaseQuantity,
        minimumQuantity: 1,
        maximumQuantity: productType === 'Solutions' ? 5 : 10,
        quantity: quantity,
        "data-t": "quantity-selector"
    }), /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({
        onClick: handleOnClick,
        disabled: loading || buttonProps.disabled
    }, buttonProps))) : /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({
        onClick: handleOnClick,
        disabled: loading || buttonProps.disabled
    }, buttonProps)));
};

export { AddToCartContainer };
//# sourceMappingURL=AddToCartContainer.js.map
